import { useEffect, useState } from "react";

const DEFAULT_RATES = {
    USD: 1,
    ZAR: 18.5,
};

function useExchangeRates() {
    const [rates, setRates] = useState(DEFAULT_RATES);
    const [loading, setLoading] = useState(true);
    const [lastUpdated, setLastUpdated] = useState(null);

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const res = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
                const data = await res.json();

                if (data?.rates) {
                    setRates({
                        USD: 1,
                        ZAR: data.rates.ZAR,
                    });

                    setLastUpdated(new Date());
                }
            } catch (error) {
                console.error("Exchange rate fetch failed, using defaults", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRates();
    }, []);

    // Convert function
    const convertPrice = (amount, fromCurrency, toCurrency) => {
        if (!amount) return 0;

        fromCurrency = fromCurrency?.toUpperCase();
        toCurrency = toCurrency?.toUpperCase();

        if (fromCurrency === toCurrency) return amount;

        if (fromCurrency === "USD" && toCurrency === "ZAR") {
            return amount * rates.ZAR;
        }

        if (fromCurrency === "ZAR" && toCurrency === "USD") {
            return amount / rates.ZAR;
        }

        return amount;
    };

    return {
        exchangeRates: rates,
        convertPrice,
        loading,
        lastUpdated,
    };
}

export default useExchangeRates;